import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import {
  Form,
  Radio,
  Button,
  Grid,
  Dropdown,  
  Label
} from 'semantic-ui-react';
import _ from 'lodash';
import { userConstants } from '../../constants/user.constants';
import { userActions } from '../../actions/user.actions';
import PropTypes from 'prop-types';
import { getBlockModeLabel, getJourneyModeLabel, getTrileanLabel } from '../../helpers/user';

class GroupFormScreen extends Component {
  constructor(props) {
    super(props);

    this.state = {
      group: {
        name: '',
        description: '',
        journeyMode: userConstants.JOURNEY_MODE_NOT_CONFIGURED,
        blockMode: userConstants.BLOCK_MODE_NOT_CONFIGURED,
        autoCreateUsers: true,
        syncManager: true,
        syncPersonalData: true,
        labels: [],
        members: [],
        approvers: [],
        active: true,
        azureAdId: '',
      },
      search: '',
      searchManager: '',    
      errors: {},
      showRepeat: false,
      submitted: false,
      loadingSync: false,
      labelOptions: [],
      selectedApproverOptions: [],
      selectedMemberOptions: [],
    };
  }

  componentDidMount() {
    const { match, dispatch } = this.props;

    this.handleSearchDebounced = _.debounce(function() {
      this.fetchUsers();
    }, 500);

    this.handleSearchManagerDebounced = _.debounce(function() {
      this.fetchManagers();
    }, 500);

    if (match.params.id) {
      dispatch(userActions.getGroup(match.params.id))
        .then(() => {
          const group = _.mapKeys(this.props.group, function (v, k) { return k[0].toLowerCase() + k.substring(1); });
          const labelOptions = group.labels.map((label) => ({ key: label.Label, text: label.Label, value: label.Label }));
          const selectedMemberOptions = group.users.filter((user) => user.Type == 1).map((user) => ({ key: user.User.Id, text: user.User.Name, value: user.User.Id}));
          const selectedApproverOptions = group.users.filter((user) => user.Type == 2).map((user) => ({ key: user.User.Id, text: user.User.Name, value: user.User.Id}));
          group.labels = group.labels.map((label) => label.Label);
          group.members = group.users.filter((user) => user.Type == 1).map((user) => user.User.Id);
          group.approvers = group.users.filter((user) => user.Type == 2).map((user) => user.User.Id);
          group.defaultWorkSchedules.forEach((item) => {
            var suffix = '_' + item.WeekDay;
            group['start' + suffix] = item.StartTime.Hours + ':' + item.StartTime.Minutes;
            group['work' + suffix] = item.WorkMinutes;
            group['lunch' + suffix] = item.LunchMinutes;
            group['start_tolerance' + suffix] = item.StartToleranceMinutes;
            group['end_tolerance' + suffix] = item.EndToleranceMinutes;
          });

          this.setState({ group, labelOptions, selectedMemberOptions, selectedApproverOptions })
        });
    }

    dispatch(userActions.fetch({ orderBy: "Name" }));    
  }

  fetchUsers() {
    const { dispatch } = this.props;
    const { search } = this.state;
    dispatch(userActions.fetch({ search, orderBy: "Name" }));
  }

  fetchManagers() {
      const { dispatch } = this.props;
      const { searchManager } = this.state;      
      dispatch(userActions.managers({ searchManager, orderBy: "Name" }));
  }

  static get propTypes() {
    return {
      me: PropTypes.any,      
      usersLoading: PropTypes.bool,
      loading: PropTypes.bool,
      group: PropTypes.any,
      match: PropTypes.any,
      users: PropTypes.any,
      loadingSync: PropTypes.bool,
    };
  }

  syncAzureAd() {
    if (confirm('Sincronizar os usuários do grupo com o Azure AD?')) {
      const { dispatch } = this.props;
      const { group } = this.state;
      dispatch(userActions.syncGroupAzureAd(group.id));
    }
  }

  syncAd() {
    if (confirm('Sincronizar os usuários do grupo com o AD?')) {
      const { dispatch } = this.props;
      const { group } = this.state;
      dispatch(userActions.syncGroupAd(group.id));
    }
  }

  simpleSearch(options, query) {
    query = query.toLowerCase();
    return options.filter(opt => {
      return opt.description && (opt.text.toLowerCase().indexOf(query) >= 0 || opt.description.toLowerCase().indexOf(query) >= 0);
    });
  }

  handleChange(field, data) {    
    const { group } = this.state;
    group[field] = data;    
    this.setState({ group });
  }

  handleUserSearchChange(search) {
    this.setState({ search });
    this.handleSearchDebounced();
  }

  handleManagerSearchChange(searchManager) {
    this.setState({ searchManager });
    this.handleSearchManagerDebounced();
  }

  validate() {
    const { group } = this.state;

    let errors = {};
    let valid = true;

    if (!group.name || group.name.length == 0) {
      errors.name = "Preencha o nome";
      valid = false;
    }

    if (!group.description || group.description.length == 0) {
      errors.description = "Preencha a descrição";
      valid = false;
    }

    this.setState({ errors });
    return valid;
  }

  handleSubmit() {
    if (!this.validate()) {
      return;
    }

    const { dispatch } = this.props;
    const { group } = this.state;

    let payload = Object.assign({}, group);
    payload.requesters = payload.members;
    if (group.azureAdSync || group.adSync) {
      payload.requesters = null;
      payload.members = null;
      payload.users = null;
    }

    const workSchedule = [];
    for (let i = 0; i < 7; i++) {
      const suffix = '_' + i;
      if (group['start' + suffix]) {
        workSchedule.push({ 
          WeekDay: i,
          StartTime: group['start' + suffix],
          WorkMinutes: parseInt(group['work' + suffix]),
          LunchMinutes: parseInt(group['lunch' + suffix]),
          StartToleranceMinutes: parseInt(group['start_tolerance' + suffix]),
          EndToleranceMinutes: parseInt(group['end_tolerance' + suffix]),
        });
      }    
    }    
    payload.workSchedule = workSchedule;
    
    if (group.id) {
      dispatch(userActions.updateGroup(group.id, payload));
    } else {
      dispatch(userActions.createGroup(payload));      
    }
  }

  blockModeOptions() {
    return [
      {key: userConstants.BLOCK_MODE_NOT_CONFIGURED, value: userConstants.BLOCK_MODE_NOT_CONFIGURED, text: getBlockModeLabel(userConstants.BLOCK_MODE_NOT_CONFIGURED)},
      {key: userConstants.BLOCK_MODE_AUTO, value: userConstants.BLOCK_MODE_AUTO, text: getBlockModeLabel(userConstants.BLOCK_MODE_AUTO)},
      {key: userConstants.BLOCK_MODE_ENABLED, value: userConstants.BLOCK_MODE_ENABLED, text: getBlockModeLabel(userConstants.BLOCK_MODE_ENABLED)},
      {key: userConstants.BLOCK_MODE_DISABLED, value: userConstants.BLOCK_MODE_DISABLED, text: getBlockModeLabel(userConstants.BLOCK_MODE_DISABLED)},
    ]
  }

  journeyModeOptions() {
    return [
      {key: userConstants.JOURNEY_MODE_NOT_CONFIGURED, value: userConstants.JOURNEY_MODE_NOT_CONFIGURED, text: getJourneyModeLabel(userConstants.JOURNEY_MODE_NOT_CONFIGURED)},
      {key: userConstants.JOURNEY_MODE_FLEXIBLE, value: userConstants.JOURNEY_MODE_FLEXIBLE, text: getJourneyModeLabel(userConstants.JOURNEY_MODE_FLEXIBLE)},
      {key: userConstants.JOURNEY_MODE_RIGID, value: userConstants.JOURNEY_MODE_RIGID, text: getJourneyModeLabel(userConstants.JOURNEY_MODE_RIGID)},
    ]
  }

  trileanOptions() {
    return [
      {key: userConstants.TRILEAN_NOT_CONFIGURED, value: userConstants.TRILEAN_NOT_CONFIGURED, text: getTrileanLabel(userConstants.TRILEAN_NOT_CONFIGURED)},
      {key: userConstants.TRILEAN_TRUE, value: userConstants.TRILEAN_TRUE, text: getTrileanLabel(userConstants.TRILEAN_TRUE)},
      {key: userConstants.TRILEAN_FALSE, value: userConstants.TRILEAN_FALSE, text: getTrileanLabel(userConstants.TRILEAN_FALSE)},
    ]
  }

  render() {
    const { loading, usersLoading, users, managers, me } = this.props;
    const { group, errors, labelOptions, selectedApproverOptions, selectedMemberOptions } = this.state;

    // Check Permission    
    if (me && me.Role != userConstants.ROLE_ADMIN) {
      window.location.href = "/";
      return;
    }

    let approverOptions = selectedApproverOptions;
    let selectedApproverKeys = selectedApproverOptions.map((item) => item.key);    
    let memberOptions = selectedMemberOptions;
    let selectedMemberKeys = selectedMemberOptions.map((item) => item.key);

    if (users && users.Results) {      
      users.Results.forEach((user) => {
        if (!selectedApproverKeys.includes(user.Id)) {          
          approverOptions.push({ key: user.Id, text: user.Name, description: user.Email, value: user.Id });
        }
        if (!selectedMemberKeys.includes(user.Id)) {          
          memberOptions.push({ key: user.Id, text: user.Name, description: user.Email, value: user.Id });
        }
      })
    }

    if (managers && managers.Results) {      
      managers.Results.forEach((user) => {
        if (!selectedApproverKeys.includes(user.Id)) {          
          approverOptions.push({ key: user.Id, text: user.Name, description: user.Email, value: user.Id });
        }        
      });
    }

    const syncButtonStyle = { marginLeft: 16, marginTop: -4 };
    
    return (
      <Fragment>
        <h1>Grupo</h1>
        <Form loading={loading} onSubmit={() => this.handleSubmit()}>
          <Form.Input required error={errors.title} label='Nome' value={group.name} name='name' type='text' onChange={(e, data) => this.handleChange("name", data.value)} placeholder='Nome do grupo' />
          { errors.name && <Label color='red'>{errors.name}</Label>}

          <Form.TextArea required error={errors.description} label='Descrição' value={group.description} name='description' onChange={(e, data) => this.handleChange("description", data.value)} type='textarea' placeholder='Descreva por que precisa das horas adicionais' />
          { errors.description && <Label color='red'>{errors.description}</Label>}
        
          <Form.Input>
            <Radio toggle checked={group.active} label='Habilitado' onChange={(e, data) => this.handleChange("active", data.checked)} />
          </Form.Input>
        
          <Form.Input>
            <Radio toggle checked={group.azureAdSync} label='Sincronizar com Azure AD' onChange={(e, data) => this.handleChange("azureAdSync", data.checked)} />
            {group.id && <Button 
              onClick={() => this.syncAzureAd()} 
              icon='refresh' 
              type='button' 
              size='mini'               
              title='Sincronizar agora'
              circular
              loading={this.props.loadingSync}
              disabled={!group.azureAdSync}
              style={syncButtonStyle} />}    
          </Form.Input>

          <Form.Input disabled={!group.azureAdSync} error={errors.azureAdId} label='ID Azure AD' value={group.azureAdId} azureAdId='azureAdId' type='text' onChange={(e, data) => this.handleChange("azureAdId", data.value)} placeholder='ID do grupo no Azure AD' />
          { errors.azureAdId && <Label color='red'>{errors.azureAdId}</Label>}

          <Form.Input>
            <Radio toggle checked={group.adSync} label='Sincronizar com AD' onChange={(e, data) => this.handleChange("adSync", data.checked)} />
            {group.id && <Button 
              onClick={() => this.syncAd()} 
              icon='refresh' 
              type='button' 
              size='mini'               
              title='Sincronizar agora'
              circular
              loading={this.props.loadingSync}
              disabled={!group.adSync}
              style={syncButtonStyle} />}    
          </Form.Input>

          <Form.Input disabled={!group.adSync} error={errors.adName} label='Nome Grupo AD' value={group.adName} id='adName' type='text' onChange={(e, data) => this.handleChange("adName", data.value)} placeholder='Nome do Grupo no AD' />
          { errors.adName && <Label color='red'>{errors.adName}</Label>}          

          <Form.Field disabled={group.azureAdSync || group.adSync}>
            <label>Membros</label>
            <Dropdown
              placeholder='Digite nome, usuário ou e-mail'
              fluid
              multiple
              selection
              loading={usersLoading}
              onChange={(e, data) => this.handleChange("members", data.value)}
              onSearchChange={(e, data) => this.handleUserSearchChange(data.searchQuery)}
              search={(opt, qry) => this.simpleSearch(opt, qry)}
              value={group.members || []}
              options={memberOptions}
            />
            { errors.members && <Label basic pointing  color='red'>{errors.members}</Label>}
          </Form.Field>

          <Form.Field>
            <Radio toggle checked={group.disableRemovedUsers} label='Desativar Bloqueio Usuários Removidos' onChange={(e, data) => this.handleChange("disableRemovedUsers", data.checked)} />
          </Form.Field>

          <Form.Field>
            <label>Aprovadores</label>
            <Dropdown
              placeholder='Digite nome, usuário ou e-mail'
              fluid
              multiple
              selection
              loading={usersLoading}
              onChange={(e, data) => this.handleChange("approvers", data.value)}
              onSearchChange={(e, data) => this.handleManagerSearchChange(data.searchQuery)}
              search={(opt, qry) => this.simpleSearch(opt, qry)}              
              options={approverOptions}
              value={group.approvers || []}
            />
            { errors.approvers && <Label basic pointing  color='red'>{errors.approvers}</Label>}
          </Form.Field>

          <Form.Field>
            <label>Labels</label>
            <Dropdown
              placeholder='Digite suas labels para integração com sistemas externos'
              fluid
              multiple
              search
              selection
              allowAdditions
              onChange={(e, data) => this.handleChange("labels", data.value)}                            
              onAddItem={(event, data) => { labelOptions.push({key: data.value, text: data.value, value: data.value}); this.setState({ labelOptions }) }}
              options={labelOptions}       
              value={group.labels || []}       
            />
            { errors.labels && <Label basic pointing  color='red'>{errors.labels}</Label>}
          </Form.Field>    

          <Form.Field required>
            <label>Modo Bloqueio</label>
            <Dropdown
              placeholder='Selecione'
              fluid
              label='Modo de Bloqueio'
              selection
              value={group.blockMode} 
              onChange={(e, data) => this.handleChange("blockMode", data.value)}
              options={this.blockModeOptions()}
            />
            { errors.blockMode && <Label basic pointing color='red'>{errors.blockMode}</Label>}
        </Form.Field>         

        <Form.Field required>
            <label>Modo Jornada</label>
            <Dropdown
              placeholder='Selecione'
              fluid
              label='Modo de Jornada'
              selection
              value={group.journeyMode} 
              onChange={(e, data) => this.handleChange("journeyMode", data.value)}
              options={this.journeyModeOptions()}
            />
            { errors.blockMode && <Label basic pointing color='red'>{errors.blockMode}</Label>}
        </Form.Field>        

        <Form.Field required>
            <label>Auto Aprovação</label>
            <Dropdown
              placeholder='Selecione'
              fluid
              label='Auto Aprovação'
              selection
              value={group.allowSelfApproval} 
              onChange={(e, data) => this.handleChange("allowSelfApproval", data.value)}
              options={this.trileanOptions()}
            />
            { errors.allowSelfApproval && <Label basic pointing color='red'>{errors.allowSelfApproval}</Label>}
        </Form.Field>        

        <Form.Field>
          <Radio toggle checked={group.autoCreateUsers} label='Criar Novos Usuários Automaticamente' onChange={(e, data) => this.handleChange("autoCreateUsers", data.checked)} />
        </Form.Field>

        <Form.Field>
          <Radio toggle checked={group.syncManager} label='Sincronizar Superiores' onChange={(e, data) => this.handleChange("syncManager", data.checked)} />
        </Form.Field>

        <Form.Field>
          <Radio toggle checked={group.syncPersonalData} label='Atualizar Dados Pessoais' onChange={(e, data) => this.handleChange("syncPersonalData", data.checked)} />
        </Form.Field>

        <h3>Jornada de Trabalho Padrão</h3>
        <Form.Field>
          <Radio toggle checked={group.syncWorkSchedule} label='Sincronizar Jornada de Trabalho' onChange={(e, data) => this.handleChange("syncWorkSchedule", data.checked)} />
        </Form.Field>

        <Grid>
          <Grid.Row>
            <Grid.Column width={4}>Dia da Semana</Grid.Column>
            <Grid.Column width={2}>Entrada</Grid.Column>
            <Grid.Column width={2}>Jornada (minutos)</Grid.Column>
            <Grid.Column width={2}>Almoço (minutos)</Grid.Column>
            <Grid.Column width={2}>Tolerância Entrada (minutos)</Grid.Column>            
            <Grid.Column width={2}>Tolerância Saída (minutos)</Grid.Column>
          </Grid.Row>

          <Grid.Row>
            <Grid.Column width={4}>
              Segunda-feira
            </Grid.Column>
            <Grid.Column width={2}>
              <Form.Input size='mini' value={group.start_1} placeholder='Ex: 08:00' name='start_1' type='text' onChange={(e, data) => this.handleChange("start_1", data.value)} />
            </Grid.Column>
            <Grid.Column width={2}>
              <Form.Input size='mini' value={group.work_1} name='work_1' type='text' onChange={(e, data) => this.handleChange("work_1", data.value)} />
            </Grid.Column>            
            <Grid.Column width={2}>
              <Form.Input size='mini' value={group.lunch_1} name='lunch_1' type='text' onChange={(e, data) => this.handleChange("lunch_1", data.value)} />
            </Grid.Column>
            <Grid.Column width={2}>
              <Form.Input size='mini' value={group.start_tolerance_1} name='start_tolerance_1' type='text' onChange={(e, data) => this.handleChange("start_tolerance_1", data.value)} />
            </Grid.Column>
            <Grid.Column width={2}>
              <Form.Input size='mini' value={group.end_tolerance_1} name='end_tolerance_1' type='text' onChange={(e, data) => this.handleChange("end_tolerance_1", data.value)} />
            </Grid.Column>
          </Grid.Row>

          <Grid.Row>
            <Grid.Column width={4}>
              Terça-feira
            </Grid.Column>
            <Grid.Column width={2}>
              <Form.Input size='mini' value={group.start_2}  placeholder='Ex: 08:00' name='start_2' type='text' onChange={(e, data) => this.handleChange("start_2", data.value)} />
            </Grid.Column>
            <Grid.Column width={2}>
              <Form.Input size='mini' value={group.work_2} name='work_2' type='text' onChange={(e, data) => this.handleChange("work_2", data.value)} />
            </Grid.Column>            
            <Grid.Column width={2}>
              <Form.Input size='mini' value={group.lunch_2} name='lunch_2' type='text' onChange={(e, data) => this.handleChange("lunch_2", data.value)} />
            </Grid.Column>
            <Grid.Column width={2}>
              <Form.Input size='mini' value={group.start_tolerance_2} name='start_tolerance_2' type='text' onChange={(e, data) => this.handleChange("start_tolerance_2", data.value)} />
            </Grid.Column>
            <Grid.Column width={2}>
              <Form.Input size='mini' value={group.end_tolerance_2} name='end_tolerance_2' type='text' onChange={(e, data) => this.handleChange("end_tolerance_2", data.value)} />
            </Grid.Column>
          </Grid.Row>        

          <Grid.Row>
            <Grid.Column width={4}>
              Quarta-feira
            </Grid.Column>
            <Grid.Column width={2}>
              <Form.Input size='mini' value={group.start_3}  placeholder='Ex: 08:00' name='start_3' type='text' onChange={(e, data) => this.handleChange("start_3", data.value)} />
            </Grid.Column>
            <Grid.Column width={2}>
              <Form.Input size='mini' value={group.work_3} name='work_3' type='text' onChange={(e, data) => this.handleChange("work_3", data.value)} />
            </Grid.Column>            
            <Grid.Column width={2}>
              <Form.Input size='mini' value={group.lunch_3} name='lunch_3' type='text' onChange={(e, data) => this.handleChange("lunch_3", data.value)} />
            </Grid.Column>
            <Grid.Column width={2}>
              <Form.Input size='mini' value={group.start_tolerance_3} name='start_tolerance_3' type='text' onChange={(e, data) => this.handleChange("start_tolerance_3", data.value)} />
            </Grid.Column>
            <Grid.Column width={2}>
              <Form.Input size='mini' value={group.end_tolerance_3} name='end_tolerance_3' type='text' onChange={(e, data) => this.handleChange("end_tolerance_3", data.value)} />
            </Grid.Column>
          </Grid.Row>

          <Grid.Row>
            <Grid.Column width={4}>
              Quinta-feira
            </Grid.Column>
            <Grid.Column width={2}>
              <Form.Input size='mini' value={group.start_4}  placeholder='Ex: 08:00' name='start_4' type='text' onChange={(e, data) => this.handleChange("start_4", data.value)} />
            </Grid.Column>
            <Grid.Column width={2}>
              <Form.Input size='mini' value={group.work_4} name='work_4' type='text' onChange={(e, data) => this.handleChange("work_4", data.value)} />
            </Grid.Column>            
            <Grid.Column width={2}>
              <Form.Input size='mini' value={group.lunch_4} name='lunch_4' type='text' onChange={(e, data) => this.handleChange("lunch_4", data.value)} />
            </Grid.Column>
            <Grid.Column width={2}>
              <Form.Input size='mini' value={group.start_tolerance_4} name='start_tolerance_4' type='text' onChange={(e, data) => this.handleChange("start_tolerance_4", data.value)} />
            </Grid.Column>
            <Grid.Column width={2}>
              <Form.Input size='mini' value={group.end_tolerance_4} name='end_tolerance_4' type='text' onChange={(e, data) => this.handleChange("end_tolerance_4", data.value)} />
            </Grid.Column>
          </Grid.Row>

          <Grid.Row>
            <Grid.Column width={4}>
              Sexta-feira
            </Grid.Column>
            <Grid.Column width={2}>
              <Form.Input size='mini' value={group.start_5}  placeholder='Ex: 08:00' name='start_5' type='text' onChange={(e, data) => this.handleChange("start_5", data.value)} />
            </Grid.Column>
            <Grid.Column width={2}>
              <Form.Input size='mini' value={group.work_5} name='work_5' type='text' onChange={(e, data) => this.handleChange("work_5", data.value)} />
            </Grid.Column>            
            <Grid.Column width={2}>
              <Form.Input size='mini' value={group.lunch_5} name='lunch_5' type='text' onChange={(e, data) => this.handleChange("lunch_5", data.value)} />
            </Grid.Column>
            <Grid.Column width={2}>
              <Form.Input size='mini' value={group.start_tolerance_5} name='start_tolerance_5' type='text' onChange={(e, data) => this.handleChange("start_tolerance_5", data.value)} />
            </Grid.Column>
            <Grid.Column width={2}>
              <Form.Input size='mini' value={group.end_tolerance_5} name='end_tolerance_5' type='text' onChange={(e, data) => this.handleChange("end_tolerance_5", data.value)} />
            </Grid.Column>
          </Grid.Row>

          <Grid.Row>
            <Grid.Column width={4}>
              Sábado
            </Grid.Column>
            <Grid.Column width={2}>
              <Form.Input size='mini' value={group.start_6}  placeholder='Ex: 08:00' name='start_6' type='text' onChange={(e, data) => this.handleChange("start_6", data.value)} />
            </Grid.Column>
            <Grid.Column width={2}>
              <Form.Input size='mini' value={group.work_6} name='work_6' type='text' onChange={(e, data) => this.handleChange("work_6", data.value)} />
            </Grid.Column>            
            <Grid.Column width={2}>
              <Form.Input size='mini' value={group.lunch_6} name='lunch_6' type='text' onChange={(e, data) => this.handleChange("lunch_6", data.value)} />
            </Grid.Column>
            <Grid.Column width={2}>
              <Form.Input size='mini' value={group.start_tolerance_6} name='start_tolerance_6' type='text' onChange={(e, data) => this.handleChange("start_tolerance_6", data.value)} />
            </Grid.Column>
            <Grid.Column width={2}>
              <Form.Input size='mini' value={group.end_tolerance_6} name='end_tolerance_6' type='text' onChange={(e, data) => this.handleChange("end_tolerance_6", data.value)} />
            </Grid.Column>
          </Grid.Row>

          <Grid.Row>
            <Grid.Column width={4}>
              Domingo
            </Grid.Column>
            <Grid.Column width={2}>
              <Form.Input size='mini' value={group.start_0}  placeholder='Ex: 08:00' name='start_0' type='text' onChange={(e, data) => this.handleChange("start_0", data.value)} />
            </Grid.Column>
            <Grid.Column width={2}>
              <Form.Input size='mini' value={group.work_0} name='work_0' type='text' onChange={(e, data) => this.handleChange("work_0", data.value)} />
            </Grid.Column>            
            <Grid.Column width={2}>
              <Form.Input size='mini' value={group.lunch_0} name='lunch_0' type='text' onChange={(e, data) => this.handleChange("lunch_0", data.value)} />
            </Grid.Column>
            <Grid.Column width={2}>
              <Form.Input size='mini' value={group.start_tolerance_0} name='start_tolerance_0' type='text' onChange={(e, data) => this.handleChange("start_tolerance_0", data.value)} />
            </Grid.Column>
            <Grid.Column width={2}>
              <Form.Input size='mini' value={group.end_tolerance_0} name='end_tolerance_0' type='text' onChange={(e, data) => this.handleChange("end_tolerance_0", data.value)} />
            </Grid.Column>
          </Grid.Row>
          
        </Grid>
          <Button type='submit' primary>Salvar</Button>
        </Form>
      </Fragment>
    );
  }
}

function mapStateToProps(state) {
  const { users } = state

  let props = {
    me: users.me || null,
    subordinates: users.subordinates || [],
    managers: users.managers || null,
    users,    
    usersLoading: users.loading,    
    loading: false
  };

  if (users && users.itemGroup) {
    props.group = users.itemGroup;
  }

  return props;
}

const connectedGroupFormScreen = connect(mapStateToProps)(GroupFormScreen);
export { connectedGroupFormScreen as GroupFormScreen };
